export interface InstagramResponse {
    loggedIn: boolean;
    url: string;
}

export interface InstagramPhoto {
    caption: string;
    id: string;
    media_type: 'VIDEO' | 'IMAGE'; // Validar si es IMAGE el otro tipo
    media_url: string;
    permalink: string;
    thumbnail_url: string;
    timestamp: string;
    username: string;
}

export interface ImagesFilter {
    search: string;
    start: number;
    limit: number;
    order: string; // id
    priority: PRIORITY;
    module: MODULES_OPTIONS; // All por defecto
}

export interface UploadImagePayload {
    file: File | string;
    relation_id: number; // 0 si es nuevo
    module: MODULES_OPTIONS; // All por defecto
    type: 'image';
    url?: boolean;
    file_module?: string; //opcional para que no suba el fisico
}

export interface ImageItem {
    id: number;
    filetype: string;
    filepath: string;
    filename: string;
    module: string;
    relation_id: string;
    url: string;
    size: number;
    use_module: MODULES_OPTIONS[];
}

export interface DeletedImage {
    deleted: boolean;
    deleted_module: string;
    message_deleted: string;
    resource_id: number;
}

export enum MODULES_OPTIONS {
    POST_EDITOR = 'post-editor',
    PPRODUCT_IMAGE = 'product-image',
    PRODUCT_CATEGORY = 'product-category',
    EDITOR = 'editor',
    OUT_MODULE = 'out_module',
    ALL = 'all',
    LOGO_FAVICON = 'logo_favicon',
    SITE_FILES = 'document'
}

export enum PRIORITY {
    DESC = 'DESC',
    ASC = 'ASC',
    A_Z = 'A-Z',
    Z_A = 'Z-A',
}

export interface UploadedItem {
    filename: string;
    filepath: string;
    filetype: string;
    id: number;
    module: string;
    relation_id: string;
    size: number;
    url: string;
}

// Relacion de recursos con modulo
export interface ResourceRelationItem {
    resources_id: number;
    relations_id: number;
    module: string;
}

export interface ResourceRelation {
    data: ResourceRelationItem[];
    attach?: boolean;
}

export interface DeleteImages {
    delete: DeleteItem[];
}

export interface DeleteItem {
    resources_id: number;
    module: string;
}

export interface ImageManagerData {
    selectedFiles: ImageItem[] | FileItem[];
    deletedImages?: DeletedImage[];
}

export interface InstagramAccountData {
    username: string;
    username_id: string;
}

export interface ResourceFilter {
    search_by: RESOURCES_SEARCH_TYPE;
    ids?: number[];
    map?: MAP_TYPE;
}

export enum RESOURCES_SEARCH_TYPE {
    GENERAL_CONFIG = 'gral_configs',
    GET_MIMES = 'get_mimes',
    KEEP_MIMES = 'keep_mimes',
    RESOURCES_IDS = 'resources_ids',
    RESOURCES = 'resources',
    RESOURCES_ATTACH = 'resources_attach',
}

export enum MAP_TYPE {
    ATTACH = 'attach',
    GROUP = 'group',
}

export interface ResourcesData {
    data: GeneralData | MimeData | KeepMimeData | ResourcesIdsData | ResourcesDataList | MapTypeResponse[];
}

export interface GeneralData {
    mimes: string[];
    count_modules: number;
    modules: string[];
    max_memory: number;
    multiple_uploads: number;
}

export interface MimeData {
    mimes: string[];
}

export interface KeepMimeData {
    keep_mimes: string[];
}

export interface ResourcesIdsData {
    resources_ids: number[];
}

export interface ResourcesDataList {
    resources: ResourceItem[];
}

export interface ResourceItem {
    id: number;
    filepath: string;
    filename: string;
    module: string;
}

export interface MapTypeResponse {
    resources_id: number;
    relations_id: number;
    module: string;
}

/*** PEXELS ***/
export enum PEXELS_ORIENTATION {
    NONE = 'none',
    LANDSCAPE = 'landscape', // (Horizontal),
    PORTRAIT = 'portrait', // (Vertical) or
    SQUARE = 'square', //(Cuadrado)
}

export enum PEXELS_LANG {
    ENG = 'en-US',
    BRA = 'pt-BR',
    ES = 'es-ES',
}

export enum PEXELS_COLORS {
    ALL = 'all',
    NONE = 'none',
    RED = 'red',
    ORANGE = 'orange',
    YELLOW = 'yellow',
    GREEN = 'green',
    TURQUOISE = 'turquoise',
    BLUE = 'blue',
    VIOLET = 'violet',
    PINK = 'pink',
    BROWN = 'brown',
    BLACK = 'black',
    GRAY = 'gray',
    WHITE = 'white',
}

export interface PEXELS_FILTER {
    ep_key: 'curated_photos' | 'search_photos';
    args: {
        per_page: number;
        page: number;
        orientation?: PEXELS_ORIENTATION;
        query?: string;
        color?: string;
    };
}

export interface PEXELS_RESPONSE {
    total_results: number;
    page: number;
    per_page: number;
    photos: PEXELS_PHOTO[];
    next_page: string;
}

export interface PEXELS_PHOTO {
    id: number;
    width: number;
    height: number;
    url: string;
    photographer: string;
    photographer_url: string;
    photographer_id: number;
    avg_color: string;
    src: PEXELS_PHOTO_SRC;
    liked: boolean;
    alt: string;
}

export interface PEXELS_PHOTO_SRC {
    original: string;
    large2x: string;
    large: string;
    medium: string;
    small: string;
    portrait: string;
    landscape: string;
    tiny: string;
}

/**
 * Definiciones para files
 */

export interface SizeStatus {
    used: number;
    free: number;
    max: number;
    usedPercentage: number;
    usedMB: number;
    maxGB: number;
}

export interface FilesResponse {
    total_items: number;
    per_page: number;
    current_page: number;
    last_page: number
    items: FileItem[];
}

export interface FileItem {
    id: number;
    filetype: string;
    filepath: string;
    filename: string;
    module: MODULES_OPTIONS;
    relation_id: string;
    url: string;
    size: number;
    created_at: string;
    type: string;
    use_module: MODULES_OPTIONS[]
}


